import React, { useEffect, useMemo, useState } from 'react'
import {Helmet} from "react-helmet";
import configuration from "../configuration";
import {loadScriptOrIgnore} from "../utils/loadScript";
import {objDeleteProperties} from "../utils/objUtils";

const ConfigLoad: React.FC<any> = ({children, noLoadStyle = false, primary = false}) => {
    const [links, setLinks] = useState<any[]>([])
    const [endLoad, setEndLoad] = useState<boolean>(false)
    const [configLoaded, setConfigLoaded] = useState<boolean>(false)
    const isPrimary = useMemo(() => primary || process.env.NODE_ENV === 'development', [primary])
    const verifyLoadCompleted = () => {
        setTimeout(() => {
            if((window as any).completeLoad){
                onLoadScript()
            }else {
                verifyLoadCompleted()
            }
        }, 10)
    }

    useEffect(() => {
        if(isPrimary){
            Promise.all([loadScriptOrIgnore(process.env.REACT_APP_LOAD_CONFIG + "base/config.js"), loadScriptOrIgnore(process.env.REACT_APP_LOAD_CONFIG + "config.js")]).then(res => {
                onLoadScript()
            })
        } else {
            verifyLoadCompleted()
        }
    }, [])
    const setWindowCompleteLoad = () => {
        setEndLoad(true)
        if(isPrimary){
           // (window as any).completeLoad = true;
        }
    }
    useEffect(() => {
        if (!configLoaded) return

        // Se non ci sono links da caricare o noLoadStyle è true, attiva subito endLoad
        if (noLoadStyle || links.length === 0) {
            setWindowCompleteLoad()
            return
        }

        // Aspetta che tutti i links siano caricati
        const linkElements = document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')
        const relevantLinks = Array.from(linkElements).filter(link =>
            links.some(l => link.href.includes(l.href) || l.href.includes(link.href))
        )

        if (relevantLinks.length === 0) {
            setWindowCompleteLoad()
            return
        }

        let loadedCount = 0
        const totalLinks = relevantLinks.length

        const handleLinkLoad = () => {
            loadedCount++
            if (loadedCount === totalLinks) {
                setWindowCompleteLoad()
            }
        }

        const handleLinkError = (e: Event) => {
            console.error('Failed to load stylesheet:', (e.target as HTMLLinkElement)?.href)
            loadedCount++
            if (loadedCount === totalLinks) {
                setWindowCompleteLoad()
            }
        }

        relevantLinks.forEach(link => {
            if (link.sheet) {
                // Link già caricato
                handleLinkLoad()
            } else {
                link.addEventListener('load', handleLinkLoad)
                link.addEventListener('error', handleLinkError)
            }
        })

        return () => {
            relevantLinks.forEach(link => {
                link.removeEventListener('load', handleLinkLoad)
                link.removeEventListener('error', handleLinkError)
            })
        }
    }, [configLoaded, links, noLoadStyle])

    const onLoadScript = () => {
        const configCustom = (window as any).config || {};
        const configBase = (window as any).configBase || {};
        const config = {
            ...configBase,
            ...configCustom,
            theme: {...(configBase.theme || {}), ...(configCustom.theme || {})},
            links: [...(configBase.links || []), ...(configCustom.links || [])]
        }
        if(isPrimary){
            const processedLinks = config.links ? config.links.map((el: any) => ({
                ...el,
                href: el?.href?.startsWith('http') ? el.href : process.env.REACT_APP_LOAD_CONFIG + el.href
            })) : []

            setLinks(processedLinks)
        }

        configuration.external = objDeleteProperties(config, ['theme', 'links'])
        if(config.page?.faviconLink && isPrimary){
            const url = config.page.faviconLink;
            const favicon = document?.querySelector('link[rel=icon]')
            if(favicon)
                (favicon as any).href= url.startsWith("http") ? url : process.env.REACT_APP_LOAD_CONFIG + url;
        }
        if(config.page?.baseTitle && isPrimary){
            document.title= config.page.baseTitle
        }
        if (config.theme) {
            configuration.theme = config.theme;
        }
        setConfigLoaded(true)
    }
    return (
        <>
            {(!noLoadStyle && isPrimary) && <Helmet link={links}/>}

            {endLoad && children}
        </>
    )
}
export default ConfigLoad
